import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MicOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M12 16.05c2.5 0 4.54-2.04 4.54-4.54V6.47c0-2.5-2.04-4.54-4.54-4.54a4.55 4.55 0 0 0-4.54 4.54v5.03c0 2.5 2.04 4.54 4.54 4.54v.01ZM9.06 6.48c0-1.62 1.32-2.94 2.94-2.94 1.62 0 2.94 1.32 2.94 2.94v5.03c0 1.62-1.32 2.94-2.94 2.94-1.62 0-2.94-1.32-2.94-2.94V6.47v.01Z"
      fill={color}
    />
    <Path
      d="M18.31 11.21c-.44 0-.8.36-.8.8 0 2.87-2.47 5.2-5.51 5.2-3.04 0-5.51-2.33-5.51-5.2 0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8 0 3.49 2.76 6.37 6.31 6.75v2.45c0 .44.36.8.8.8.44 0 .8-.36.8-.8v-2.45c3.54-.38 6.31-3.26 6.31-6.75 0-.44-.36-.8-.8-.8Z"
      fill={color}
    />
  </Svg>
)

export default MicOutlined
